import React from 'react';
import Spinner from '../../atoms/Spinner';

type LoaderProps = {
  showLoader: boolean;
};

const Loader: React.FC<LoaderProps> = ({ showLoader }) => {
  if (!showLoader) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray bg-opacity-50 z-50">
      <Spinner className="w-5 h-5 border-2 border-dashed rounded-full animate-spin bg-violet2 dark:bg-transparent" />
    </div>
  );
};

export default Loader;
